export const ADMIN = "admin";
export const SUPERADMIN = "super-admin";

export const token = localStorage.getItem("accessToken");
export const clear1 = () =>{
    localStorage.removeItem("accessToken");  
}